import { computed } from 'vue'
import { features, isFeatureEnabled } from '@/config/features'

/**
 * Composable for accessing feature flags
 */
export function useFeatures() {
  const stripeEnabled = computed(() => features.stripe.enabled)
  const showBillingPage = computed(() => features.stripe.showBillingPage)
  const showUpgradeButtons = computed(() => features.stripe.showUpgradeButtons)
  const showPaymentLinks = computed(() => features.stripe.showPaymentLinks)
  const showCustomerPortal = computed(() => features.stripe.showCustomerPortal)
  
  return {
    features,
    isFeatureEnabled,
    stripeEnabled,
    showBillingPage,
    showUpgradeButtons,
    showPaymentLinks,
    showCustomerPortal
  }
}